import React from "react";
import "../../styles.css";
import { useState, useEffect } from "react";
import {
  Elements,
  useStripe,
  useElements,
  CardElement,
  PaymentElement,
} from "@stripe/react-stripe-js";
import { axiosReqConfig } from "../../functions/axiosRequest";
import { API_IP } from "../../global_variables";
import { loadStripe } from "@stripe/stripe-js";

const NewCardModal = ({
  handleClose,
  showModal,
  toggleAlert,
  toggleRefresh,
  clientSecret,
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isMounted, setIsMounted] = useState(false);
  const [paymentElementMounted, setPaymentElementMounted] = useState(false);
  useEffect(() => {
    setIsMounted(true);
    return () => setIsMounted(false);
  }, []);

  const handleSaveCard = async () => {
    setIsLoading(true);
    setError(null);

    if (
      !stripe ||
      !elements ||
      !clientSecret ||
      !isMounted ||
      !paymentElementMounted
    ) {
      setIsLoading(false);
      return;
    }

    try {
      const submitResult = await elements.submit();
      const result = await stripe.confirmSetup({
        elements,
        clientSecret,
        confirmParams: {
          return_url: `${window.location.origin}/completion`,
        },
        redirect: "if_required",
      });

      if (result.error) {
        setError(result.error.message);
        console.error(result.error);
      } else {
        handleClose();
        toggleRefresh();
        toggleAlert();
      }
    } catch (err) {
      console.error("Error saving card:", err);
      setError("Failed to save card. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };
  if (!showModal) {
    return null;
  }
  return (
    <div className="startTime-modal-overlay" onClick={handleClose}>
      <div
        className="startTime-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="alert-modal-header">
          <h2>Save a New Card</h2>
        </div>

        <div className="payment-element-container">
          <PaymentElement onReady={() => setPaymentElementMounted(true)} />
        </div>
        <div className="new-card-footer">
          {error && <div className="error">{error}</div>}
          {!isLoading ? (
            <button
              type="button"
              className="save-card-button"
              onClick={handleSaveCard}
              disabled={
                !stripe ||
                !elements ||
                isLoading ||
                !clientSecret ||
                !paymentElementMounted
              }
            >
              Save Card
            </button>
          ) : (
            <>
              <img
                className="small-loading-icon"
                src={require("../../images/smallLoading.gif")}
                alt="Clock icon"
              />
            </>
          )}
          {isLoading && <div className="loading">Saving card...</div>}
        </div>
      </div>
    </div>
  );
};

export default NewCardModal;
